import { render, staticRenderFns } from "./ModalCode.vue?vue&type=template&id=4f56fac5&scoped=true"
import script from "./ModalCode.vue?vue&type=script&lang=js"
export * from "./ModalCode.vue?vue&type=script&lang=js"
import style0 from "./ModalCode.vue?vue&type=style&index=0&id=4f56fac5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56fac5",
  null
  
)

export default component.exports